<template>
  <el-container class="curri_content">
    <el-header>
      <index-header></index-header>
    </el-header>
    <el-main>
      <div class="mainContent">
        <p @click="back()" style="margin-bottom:10px;cursor: pointer;"><i class="icon el-icon-arrow-left"></i>{{$t('global.backToSchedule')}}</p>
        <div class="main-arrow">
          <div class="flex_between">
            <h3 class="font_36_reg">{{$t('myChild.editChildProfile')}}</h3>
            <el-button type="primary" @click="addChild" v-if="childData.length<6">{{$t('myChild.addChild')}}</el-button>
          </div>
          <div class="main-info">
            <div class="select-part">
              <div class="addForm">
                <div class="addFormList" v-for="(item,i) in childData" :key='i'>
                  <img :src="item.avatar"  />
                  <p class="font_16 color_grey">{{$t('myChild.childName')}}</p>
                  <p class="font_18_reg color_black">{{item.nickname}}</p>
                  <p class="font_16 color_grey">{{$t('myChild.childBirth')}}</p>
                  <p class="font_18_reg color_black">{{item.birth_date}}</p>
                  <div class="flex_justify_end">
                    <span @click="editChild(item)" class="flex_justify_center"><i></i>{{$t('myChild.edit')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <index-footer></index-footer>
    </el-footer>
  </el-container>
</template>

<script>
import IndexHeader from './views/header'
import IndexFooter from './views/footer'
export default {
  components: {
    IndexHeader,
    IndexFooter
  },
  data () {
    return {
      childData: []
    }
  },
  // watch:{
  //   //监控列表总数据量的变化
  //   datacourse(newVal,oldVal){
  //       //当总数据量变化时，重新计算分页的数量（需要显示多少页）
  //       this.data =newVal;
  //   }
  // },
  created () {
    this.getChild()
  },
  methods: {
    back () {
      this.$router.push({ path: '/index' })
    },
    getChild () {
      this.$http.get('/api/students').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.childData = res.data.data
          // store.setChildList(res.data.data)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    editChild (item) {
      this.$router.push({ path: '/add?one=1&edit=' + encodeURIComponent(JSON.stringify(item)) })
    },
    addChild () {
      this.$router.push({ path: '/add?add=0' })
    }
  }
}
</script>

<style lang="less" scoped>
.curri_content{
  position: relative;
  .el-header{
    height: 88px!important;
    background: rgba(53,54,67,0.90);
    width: 100%;
    padding:0;
  }
  .el-main{
    overflow: inherit;
    padding:0;
    margin-bottom:254px;
      z-index:22;
    .mainContent{
      width:1200px;
      margin:25px auto 54px;
      .main-arrow{
        background: #FFFFFF;
        border: 1px solid #FFD1C6;
        border-radius: 5px;
        padding:40px;
        margin: 10px 100px;
        button{
          width: 120px;
          height: 40px;
          background: #ff6440;
          border-radius: 4px;
          border: 1px solid #ff6440;
          margin-top: 20px;
          margin-bottom: 15px;
          color: #fff;
          font-size: 16px;
          font-family: Sofia Pro-Bold;
          box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
        }
        .main-info{
          // padding:40px 60px;
          .select-part{
            // width:100%;
            // background: rgba(235, 233, 241, 0.5);
            border-radius: 5px;
            padding:23px 32px;
            .addForm{
              display: flex;
              flex-wrap: wrap;
              .addFormList{
                  width: 360px;
                  border: 3px dashed #FF6440;
                  padding: 20px;
                  margin-right:40px;
                  margin-bottom:30px;
                  &:nth-child(2n){
                    margin-right:0;
                  }
                  img{
                    width:80px;
                    height:80px;
                    cursor: pointer;
                    margin:10px 0;
                  }
                  p{
                    margin-top:3px;
                    margin-bottom:10px;
                  }
                  span{
                    width: 102px;
                    height: 36px;
                    background: #ff6440;
                    border-radius: 4px;
                    border: 1px solid #ff6440;
                    margin-top: 20px;
                    margin-bottom: 15px;
                    color: #fff;
                    font-size: 16px;
                    font-family: Sofia Pro-Bold;
                    cursor: pointer;
                    i{
                      width:24px;
                      height:24px;
                      display: inline-block;
                      background: url("../assets/edit-white.svg") no-repeat center center;
                    }
                  }
                  .editBtn{
                    width:24px;
                    height:24px;
                    margin:10px;
                  }
                  /deep/ .el-form-item{
                    margin-bottom: 10px;
                    .el-form-item__content{
                      display: flex;
                      margin:0!important;
                      .el-input{
                        border-bottom: 1px solid #a5a5a5;
                      }
                      .errorPass{
                        border-bottom: 1px solid #fc424c;
                      }
                      .el-input__inner {
                        -moz-appearance: none;
                        width:100%;
                        height: 40px;
                        border:none;
                        background: none;
                        font-size: 16px;
                        color: #353643;
                        font-family: Sofia Pro-Regular;
                        letter-spacing: 0px;
                        outline: 0;
                        padding:0 40px 0 0;
                        border-radius: 0;
                      }
                      .el-form-item__error{
                        // margin-top:7px;
                        font-size: 14px;
                        color: #fc424c;
                        font-family: Sofia Pro-Regular;
                        width: max-content;
                      }
                    }
                  }

              }
            }
          }
        }
      }
    }
  }
  .el-footer{
    width:100%;
    height:inherit!important;
    padding:0;
    position: absolute;
    bottom:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/allChild.vue